import * as crypto from 'crypto-js';
import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as Bootstrap from 'bootstrap';

import dummy from './plugins';

import GoogleMapsLoader from 'google-maps';

import DialogRegion from '../../lib/views/dialogRegion/dialogRegion';
import DialogRouterRegion from '../../lib/views/dialogRouterRegion/dialogRouterRegion';

import View_Register from '../views/register/register';

import language from '../../common/language';
import config from '../../common/config';

import * as Entities_PublicShopOrder from '../entities/publicShopOrder';
import * as Entities_PublicShopProduct from '../entities/publicShopProduct';

import * as Entities_PublicConfigShopFreight from '../entities/publicConfigShopFreight';
import * as Entities_PublicConfigShopProduct from '../entities/publicConfigShopProduct';
import * as Entities_PublicConfigSubscription from '../entities/publicConfigSubscription';
import * as Entities_PublicCustomSubscription from '../entities/publicCustomSubscription';
import * as Entities_PublicConfigSubscriptionJob from '../entities/publicConfigSubscriptionJob';
import * as Entities_PublicCustomSubscriptionJob from '../entities/publicCustomSubscriptionJob';
import * as Entities_PublicConfigSubscriptionPayment from '../entities/publicConfigSubscriptionPayment';
import * as Entities_PublicConfigSubscriptionValidate from '../entities/publicConfigSubscriptionValidate';
import * as Entities_PublicCustom from '../entities/publicCustom';
import * as Entities_PublicCustomWebpageItem from '../entities/publicCustomWebpageItem';
import * as Entities_PublicCustom2 from '../entities/publicCustom2';
import * as Entities_PublicRecaptchaRegister from '../entities/PublicRecaptchaRegister';
import * as Entities_PublicRecaptchaContact from '../entities/PublicRecaptchaContact';
import * as Entities_PublicRecaptchaInfoScreenContact from '../entities/PublicRecaptchaInfoScreenContact';
import * as Entities_PublicRecaptchaForgotPassword from '../entities/PublicRecaptchaForgotPassword';
import * as Entities_PublicRecaptchaShopOrder from '../entities/PublicRecaptchaShopOrder';
import * as Entities_PublicIdentity from '../entities/PublicIdentity';
import * as Entities_PublicPaymentGatewayMD5 from '../entities/PublicPaymentGatewayMD5';
import * as Entities_Empty from '../../lib/entities/empty';

import * as Entities_PublicShopCart from '../entities/publicShopCart';

import * as Entities_PublicSetting from '../../common/entities/publicSetting';

import * as Entities_SearchEvent from '../entities/searchEvent';
import * as Entities_SearchEventQuery from '../entities/searchEventQuery';

import * as Entities_LanguageSetting from '../../common/entities/languageSetting';
import * as Entities_LanguageValidation from '../../common/entities/languageValidation';
import * as Entities_Memory from '../../portal/entities/memory';

import * as Entities_PublicConfigSetting from '../entities/publicConfigSetting';

import Region_Header from '../views/region/header/header';
import Region_Menu from '../views/region/menu/menu';

const oidc = require('../../plugin/oidc-client-ts');

var headerRegion = Marionette.Region.extend({
    el: '#headerRegion'
});

var menuRegion = Marionette.Region.extend({
    el: '#menuRegion'
});

var languageSelectorRegion = Marionette.Region.extend({
    el: '#languageSelectorRegion'
});


var contentRegion = Marionette.Region.extend({
    el: '#contentRegion'
});

var footerRegion = Marionette.Region.extend({
    el: '#footerRegion'
});

var dialogRegion = DialogRegion.extend({
    el: '#dialogRegion'
});

var dialogRouterRegion = DialogRouterRegion.extend({
    el: '#dialogRouterRegion'
});

var app = module.exports = Marionette.Application.extend({
    regions: {
        headerRegion: headerRegion,
        menuRegion: menuRegion,
        languageSelectorRegion: languageSelectorRegion,
        contentRegion: contentRegion,
        footerRegion: footerRegion,
        dialogRegion: dialogRegion,
        dialogRouterRegion: dialogRouterRegion
    },

    onStart: function (options) {

        $.ajaxSetup({ cache: false });

        language.getDefault();
        var busylightboard_userCultureName = language.getCookie('busylightboard_userCultureName');
        window.busylightboard.config.cultureName = busylightboard_userCultureName;

        //oidc.Log.setLogger(console);

        //const crypto = require('crypto-js');
        //var verifier = crypto.lib.WordArray.random(32);

        //var hmac = crypto.HmacSHA256(verifier, 'secretKey');
        //var hash = hmac.toString(crypto.enc.Hex);

        /*const mgr = new oidc.UserManager({ userStore: localStorage });

        mgr.events.addUserLoaded((args) => {
            mgr.getUser().then((user) => {
                this._user = user;
            });
        });*/

        //var user;

        //user = mgr.getUser();

        /*(async () => {
           user = await mgr.getUser();
        })();*/

        //const settings = {
        //    authority: 'https://localhost:44313',
        //    scope: 'openid',
        //    client_id: 'luxaforboardclient',
        //    redirect_uri: 'http://localhost:7099/signin-callback.html',
        //    response_type: 'code',
        //    userStore: new oidc.WebStorageStateStore({
        //        store: window.localStorage
        //    })
        //};

        //oidc.Log.setLogger(console);
        //oidc.Log.setLevel(oidc.Log.INFO);

        //const mgr = new oidc.UserManager(settings);
        //const client = mgr._client;
        //this.mgr = mgr;

        //function log() {
        //    console.log(...arguments);
        //}

        //this.userManager = userManager.getUser();






        //        if ()
        //        this.userManager = userManager.getUser();
        //            if (this.mgr.getUser()) {
        //            const accessToken = this.mgr.access_token;
        //            } //else {
        ////                login();
        //  //          }




        //const mgr = userManager.getUser();
        //if (user) {
        //    const accessToken = user.access_token;
        //}




        //var authConfig = config.getAuthConfig();
        //this.mgr = new OidcTokenManager(authConfig);
        //window.mgr = this.mgr;

        /*window.userManager = this.userManager;*/





        //mgr.addOnTokenExpired(function () {
        //    window.app.router.navigate("#accessTokenLifetime");
        //    window.app.router.accessTokenLifetime();

        //    /*localStorage.setItem('events4usUser_FirstName','');
        //    localStorage.setItem('events4usUser_AttPerson','');
        //    localStorage.setItem('events4usUser_Organisation',0);

        //    var userChannel = Backbone.Radio.channel('app');
        //    userChannel.trigger('Region_Header:setLoginName');*/
        //});

        var oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        this.oneWeekAgo = oneWeekAgo / 100;

        var self = this;

        //GoogleMapsLoader.LIBRARIES = config.googleMapsLoaderLIBRARIES();
        //GoogleMapsLoader.KEY = config.googleMapsLoaderKEY();
        //GoogleMapsLoader.load(function (google) {
        var languageCallback = function (resource) {
            window.resources = resource[0].attributes;

            const settings = {
                authority: 'https://localhost:44313',
                scope: 'openid api1',
                client_id: 'mvc',
                redirect_uri: 'https://localhost:7099/signin-callback.html',
                response_type: 'code',
                userStore: new oidc.WebStorageStateStore({ store: window.localStorage })
            };

            self.mgr = new oidc.UserManager(settings);

            self.mgr.signinRedirect({
                extraQueryParams: {
                    ui_locales: 'da-DK'//config.cultureName()
                    //identity_provider: 'Local',
                    //hardcoded_identity_id: '1',
                }
            });




            //self.mgr = new oidc.UserManager({ userStore: localStorage });
            //self.mgr = new oidc.UserManager({
            //    userStore: new oidc.WebStorageStateStore({ store: localStorage })
            //});


            /*if (self.mgr !== undefined) {
                (async () => {
                    const user = await self.mgr.getUser();

                    self.user = self.mgr.getUser();

                    if (self.user && self.user.access_token) {
                        window.location.replace("portal.html");
                    }
                    else {
                        return self.mgr.signinRedirect({
                            //extraQueryParams: {
                            //    identity_provider: 'Local',
                            //    hardcoded_identity_id: '1',
                            //}
                        });
                        window.app.router.navigate("#accessTokenLifetime");
                        window.app.router.accessTokenLifetime();
                    }
                })();*/
            //}

            var callback = function () {
                self.initContent();
            }

            self.setupEntities(callback);


        }

        //var timeout_id = setTimeout(function () {
        language.setLanguage(busylightboard_userCultureName, languageCallback);
        //}, 10000);
        //});
    },
    setupEntities: function (callback) {

        var self = this;

        this.entities = {};
        this.entities.collections = {};
        this.entities.models = {};

        this.entities.collections.publicShopCart = new Entities_PublicShopCart.Collection();
        this.entities.models.shopSetting = new Entities_Empty.Model();
        this.entities.models.shopSetting.attributes.SelectedVat = true;

        this.entities.models.publicShopOrder = new Entities_PublicShopOrder.Model();
        this.entities.collections.publicShopProduct = new Entities_PublicShopProduct.Collection();

        this.entities.collections.publicConfigShopFreight = new Entities_PublicConfigShopFreight.Collection();
        this.entities.collections.publicConfigShopProduct = new Entities_PublicConfigShopProduct.Collection();
        this.entities.collections.publicConfigSubscription = new Entities_PublicConfigSubscription.Collection();
        this.entities.collections.publicCustomSubscription = new Entities_PublicCustomSubscription.Collection();
        this.entities.collections.publicConfigSubscriptionJob = new Entities_PublicConfigSubscriptionJob.Collection();
        this.entities.collections.publicCustomSubscriptionJob = new Entities_PublicCustomSubscriptionJob.Collection();
        this.entities.collections.publicConfigSubscriptionPayment = new Entities_PublicConfigSubscriptionPayment.Collection();
        this.entities.collections.publicConfigSubscriptionValidate = new Entities_PublicConfigSubscriptionValidate.Collection();
        this.entities.collections.publicCustom = new Entities_PublicCustom.Collection();
        this.entities.collections.publicCustom2 = new Entities_PublicCustom2.Collection();
        this.entities.collections.publicCustomWebpageItem = new Entities_PublicCustomWebpageItem.Collection();
        this.entities.models.price = new Entities_Empty.Model();
        this.entities.models.publicRecaptchaContact = new Entities_PublicRecaptchaContact.Model();
        this.entities.models.publicRecaptchaInfoScreenContact = new Entities_PublicRecaptchaInfoScreenContact.Model();
        this.entities.models.publicRecaptchaForgotPassword = new Entities_PublicRecaptchaForgotPassword.Model();
        this.entities.models.publicRecaptchaShopOrder = new Entities_PublicRecaptchaShopOrder.Model();
        this.entities.collections.publicConfigSetting = new Entities_PublicConfigSetting.Collection();

        this.entities.models.publicPaymentGatewayMD5 = new Entities_PublicPaymentGatewayMD5.Model();

        this.entities.models.publicRecaptchaRegister = new Entities_PublicRecaptchaRegister.Model();
        this.entities.models.publicRecaptchaRegister.attributes.Name = '';
        this.entities.models.publicRecaptchaRegister.attributes.Contactperson_Name = '';
        this.entities.models.publicRecaptchaRegister.attributes.Contactperson_Phone = '';
        this.entities.models.publicRecaptchaRegister.attributes.Contactperson_Email = '';
        this.entities.models.publicRecaptchaRegister.attributes.CultureName = config.cultureName();

        this.entities.models.publicRecaptchaRegister.attributes.AccountVerify = 0;
        this.entities.models.publicRecaptchaRegister.attributes.Email = '';
        this.entities.models.publicRecaptchaRegister.attributes.Password = '';
        this.entities.models.publicRecaptchaRegister.attributes.PasswordConfirm = '';

        this.entities.models.publicRecaptchaRegister.attributes.Address01 = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address01_Supplement = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address01_administrative_area_level_1 = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address01_administrative_area_level_2 = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address01_administrative_area_level_3 = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address01_country = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address01_lat = 0;
        this.entities.models.publicRecaptchaRegister.attributes.Address01_lng = 0;
        this.entities.models.publicRecaptchaRegister.attributes.Address01_locality = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address01_postal_code = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address01_route = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address01_street_number = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address01_sublocality = '';

        this.entities.models.publicRecaptchaRegister.attributes.Address02 = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address02_Supplement = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address02_administrative_area_level_1 = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address02_administrative_area_level_2 = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address02_administrative_area_level_3 = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address02_country = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address02_lat = 0;
        this.entities.models.publicRecaptchaRegister.attributes.Address02_lng = 0;
        this.entities.models.publicRecaptchaRegister.attributes.Address02_locality = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address02_postal_code = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address02_route = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address02_street_number = '';
        this.entities.models.publicRecaptchaRegister.attributes.Address02_sublocality = '';

        //this.entities.models.publicRecaptchaRegister.attributes.WrongAddress = false;

        this.entities.collections.searchEvent = new Entities_SearchEvent.Collection();
        this.entities.models.searchEventQuery = new Entities_SearchEventQuery.Model();
        this.entities.models.searchEventQuery.attributes.Radius = '400000000'; //window.resources['X100034'];
        this.entities.models.searchEventQuery.attributes.Country = window.resources['X100001'];
        this.entities.models.searchEventQuery.attributes.CountryCode = window.resources['X100002'];
        this.entities.models.searchEventQuery.attributes.Address = this.entities.models.searchEventQuery.attributes.Country;
        var startDate = new Date();
        var strLocalStartDate = startDate.getDate().toString() + '/' + (startDate.getMonth() + 1) + '/' + startDate.getFullYear().toString();
        //this.entities.models.searchEventQuery.attributes.UtcStartDate = strLocalStartDate;
        this.entities.models.searchEventQuery.attributes.UtcStartDate = '';

        this.entities.models.publicSetting = new Entities_PublicSetting.Model();

        this.entities.collections.languageSetting = new Entities_LanguageSetting.Collection();
        this.entities.collections.languageValidation = new Entities_LanguageValidation.Collection();

        //$.getJSON( {
        //    url  : 'https://maps.googleapis.com/maps/api/geocode/json',
        //    data : {
        //        sensor  : false,
        //        address : this.entities.models.searchEventQuery.attributes.CountryCode
        //    },
        //    success : function( data, textStatus ) {
        //        console.log( textStatus, data );
        //        self.entities.models.searchEventQuery.attributes.Latitude = data.results[0].geometry.location.lat;
        //        self.entities.models.searchEventQuery.attributes.Longitude = data.results[0].geometry.location.lng;
        //    }
        //} );

        self.entities.collections.languageValidation.fetch({
            parseField: config.cultureName(),
            success: function (mode, response) {
                self.entities.collections.languageValidation_Collection = new Entities_Memory.Collection(self.entities.collections.languageValidation.models[0].attributes.Collection);

                var i = 0;
            },
            error: function (mode, response) {
                var i = 0;
            }
        }
        );


        self.entities.collections.languageSetting.fetch({
            success: function (mode, response) {
                Backbone.history.start();

                self.setupHeader();
                self.setupTemplate();

                callback();
            },
            error: function (mode, response) {
            }
        })

        //this.entities.collections.publicConfigSubscription.fetch({
        //    silent: true,
        //    wait:true,
        //    success: function (mode, response) {
        //        $.when(
        //            self.entities.models.publicSetting.fetch({
        //                success: function (mode, response) {
        //                },
        //                error: function (mode, response) {
        //                }
        //            }),
        //            self.entities.collections.publicConfigShopProduct.fetch({
        //                success: function (mode, response) {
        //                },
        //                error: function (mode, response) {
        //                }
        //            }),
        //            self.entities.collections.publicConfigShopFreight.fetch({
        //                success: function (mode, response) {
        //                },
        //                error: function (mode, response) {
        //                }
        //            }),
        //            self.entities.collections.publicConfigSubscriptionJob.fetch({
        //                success: function (mode, response) {
        //                },
        //                error: function (mode, response) {
        //                }
        //            }),
        //            self.entities.collections.publicConfigSubscriptionPayment.fetch({
        //                success: function (mode, response) {
        //                },
        //                error: function (mode, response) {
        //                }
        //            }),
        //            self.entities.collections.publicConfigSubscriptionValidate.fetch({
        //                success: function (mode, response) {
        //                },
        //                error: function (mode, response) {
        //                }
        //            }),
        //            self.entities.collections.publicConfigSetting.fetch({
        //                success: function (mode, response) {
        //                },
        //                error: function (mode, response) {
        //                },
        //            }),
        //            self.entities.collections.languageSetting.fetch({
        //                success: function (mode, response) {
        //                    //self.entities.collections.LanguageSetting = new Backbone.Collection(response.Collection);
        //                },
        //                error: function (mode, response) {
        //                }
        //            }),//,
        //            //self.entities.collections.searchEvent.fetch({
        //            //    country: self.entities.models.searchEventQuery.attributes.CountryCode,
        //            //    first: true,
        //            //    success: function (mode, response) {

        //            //    },
        //            //    error: function (mode, response) {
        //            //    }
        //            //})
        //        ).done(function () {
        //            self.entities.collections.publicConfigSubscription.fullCollection.forEach(function (entry) {
        //                entry.attributes.CalcPrice = 0;
        //            });

        //            Backbone.history.start();

        //            self.setupHeader();
        //            self.setupTemplate();

        //            callback();
        //            //self.firstRoute('#priceInfo');
        //        });
        //    },
        //    error: function (mode, response) {
        //    }
        //});


    },
    firstRoute: function (route, validate) {
        //route = '#index'

        switch (route) {
            case '#waiting':
                window.app.router.navigate("#waiting");
                window.app.router.waiting();
                break;
            case '#index':
                window.app.router.navigate("#index");
                window.app.router.index();
                break;
            case '#price':
                window.app.router.navigate("#price");
                window.app.router.price();
                break;
            case '#forgotPassword':
                window.app.router.navigate("#forgotPassword");
                window.app.router.forgotPassword();
                break;
        }
    },
    initContent: function () {
        $.valHooks.textarea = {
            get: function (elem) {
                return elem.value.replace(/\r?\n/g, "\r\n");
            }
        };

        var self = this;

        if (window.app.router.oldView == null) {
            //this.firstRoute("#index", false);
        }
    },
    initSetting: function () {
    },
    setupHeader: function () {
        this.headerRegion.show(new Region_Header({ app: this }));

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('Region_Menu:setLoginName');
    },
    setupTemplate: function () {
    }
});



